export type PaymentsLocale = 'ru' | 'kk';

const RU = {
  'tab.transactions': 'Платежи',
  'tab.invoices': 'Счета',
  'tab.fiscal': 'Фискализация',
  'tab.reconciliation': 'Сверка',
  'tab.providers': 'Провайдеры',
  'module.subtitle': 'Транзакции, счета, фискализация, сверка источников и провайдеры',
  'tx.title': 'Платёжные операции',
  'tx.date': 'Дата',
  'tx.provider': 'Провайдер',
  'tx.method': 'Способ',
  'tx.method.pos': 'Касса',
  'tx.method.cash': 'Наличные',
  'tx.method.card': 'Карта',
  'tx.method.kaspi': 'Kaspi',
  'tx.method.invoice': 'По счёту',
  'tx.kind': 'Вид',
  'tx.amount': 'Сумма',
  'tx.status': 'Статус',
  'tx.external': 'Идентификатор провайдера',
  'tx.reason': 'Причина отказа',
  'tx.refund': 'Вернуть',
  'tx.refundAmount': 'Сумма возврата, ₸',
  'tx.refundAll': 'Весь остаток',
  'tx.refundDone': 'Возврат проведён',
  'tx.empty': 'Операций нет',
  'tx.filter': 'Клиент',
  'tx.filterHint': 'Найдите клиента по телефону или номеру автомобиля — покажем его операции.',
  'tx.load': 'Показать',
  'tx.kind.charge': 'Списание',
  'tx.kind.refund': 'Возврат',
  'tx.kind.authorize': 'Авторизация',
  'tx.kind.capture': 'Подтверждение',
  'tx.status.pending': 'В обработке',
  'tx.status.authorized': 'Авторизован',
  'tx.status.captured': 'Проведён',
  'tx.status.failed': 'Отклонён',
  'tx.status.refunded': 'Возвращён',
  'tx.partialRefund': 'Частичный возврат',
  'reason.insufficient_funds': 'Недостаточно средств',
  'reason.card_expired': 'Срок карты истёк',
  'reason.declined': 'Отклонено банком',
  'reason.provider_unavailable': 'Провайдер недоступен',
  'inv.title': 'Счета юридическим лицам',
  'inv.consolidate.title': 'Единый счёт за месяц по визитам автопарка',
  'inv.consolidate.hint':
    'Собирается сам в начале следующего месяца. Здесь — собрать за выбранный месяц сейчас; повтор ничего не дублирует.',
  'inv.consolidate.month': 'Месяц',
  'inv.consolidate.run': 'Собрать счета',
  'inv.consolidate.done': 'Выставлено счетов: {count}',
  'inv.number': 'Номер',
  'inv.customer': 'Клиент',
  'inv.amount': 'Сумма',
  'inv.status': 'Статус',
  'inv.due': 'Срок',
  'inv.paid': 'Оплачен',
  'inv.pay': 'Отметить оплату',
  'inv.empty': 'Счетов нет',
  'inv.status.issued': 'Выставлен',
  'inv.status.paid': 'Оплачен',
  'inv.status.cancelled': 'Отменён',
  'stmt.title': 'Банковская выписка',
  'stmt.hint':
    'Загрузите выписку в формате 1С (1CClientBankExchange): входящие платежи с номером счёта в назначении и той же суммой закроют счёт сами.',
  'stmt.upload': 'Загрузить выписку',
  'stmt.busy': 'Разносим выписку…',
  'stmt.replayed': 'Эта выписка уже загружалась — показан прежний итог, повторно ничего не разнесено.',
  'stmt.summary':
    'Документов {documents}, входящих {incoming}: оплачено {matched}, уже оплачены {alreadyPaid}, сумма не совпала {amountMismatch}, чужой плательщик {payerMismatch}, счёт не найден {notFound}, разнесено раньше {repeated}',
  'stmt.empty': 'Входящих платежей в выписке нет',
  'stmt.doc': 'Документ',
  'stmt.date': 'Дата',
  'stmt.amount': 'Сумма',
  'stmt.payer': 'Плательщик',
  'stmt.purpose': 'Назначение',
  'stmt.invoice': 'Счёт',
  'stmt.outcome': 'Итог',
  'stmt.repeated': 'из прошлой выписки',
  'stmt.outcome.matched': 'Счёт оплачен',
  'stmt.outcome.already_paid': 'Уже оплачен',
  'stmt.outcome.amount_mismatch': 'Сумма не совпала',
  'stmt.outcome.payer_mismatch': 'Чужой плательщик',
  'stmt.outcome.not_found': 'Счёт не найден',
  'stmt.history': 'Загруженные выписки',
  'stmt.file': 'Файл',
  'stmt.period': 'Период',
  'stmt.loadedAt': 'Загружена',
  'fiscal.title': 'Фискальные документы',
  'fiscal.queue': 'Очередь непереданных',
  'fiscal.retry': 'Передать в ОФД',
  'fiscal.number': 'Фискальный номер',
  'fiscal.ofd': 'Идентификатор ОФД',
  'fiscal.kind': 'Вид',
  'fiscal.offline': 'Офлайн',
  'fiscal.attempts': 'Попыток',
  'fiscal.error': 'Последняя ошибка',
  'fiscal.empty': 'Документов нет',
  'fiscal.kind.receipt': 'Чек',
  'fiscal.kind.refund': 'Чек возврата',
  'fiscal.transmitted': 'Передан',
  'fiscal.pending': 'Ожидает передачи',
  'fiscal.skipped': 'Чек выдала прежняя ККМ',
  'fiscal.retried': 'Проверено {checked}, передано {transmitted}, не удалось {failed}',
  'recon.title': 'Сверка трёх источников',
  'recon.run': 'Запустить сверку',
  'recon.day': 'Дата',
  'recon.provider': 'Провайдер',
  'recon.system': 'В системе',
  'recon.providerCount': 'У провайдера',
  'recon.fiscalCount': 'Фискальных',
  'recon.findings': 'Расхождений',
  'recon.empty': 'Расхождений нет',
  'recon.incident': 'Расхождение — это инцидент, а не строка отчёта',
  'recon.never': 'Сверка ещё не запускалась',
  'recon.kind': 'Вид расхождения',
  'recon.kind.missing_in_provider': 'Нет у провайдера',
  'recon.kind.missing_in_system': 'Нет в системе',
  'recon.kind.amount_mismatch': 'Расходятся суммы',
  'recon.kind.missing_fiscal': 'Нет фискального документа',
  'recon.kind.orphan_fiscal': 'Фискальный документ без операции',
  'prov.title': 'Платёжные провайдеры и ОФД',
  'prov.code': 'Код',
  'prov.kind': 'Назначение',
  'prov.adapter': 'Адаптер',
  'prov.endpoint': 'Адрес',
  'prov.credential': 'Переменная окружения с ключом',
  'prov.credentialHint':
    'Только ИМЯ переменной окружения: заглавные латинские буквы, цифры и подчёркивание. Значение читается из окружения и в базу не попадает.',
  'prov.credentialInvalid':
    'Это похоже на само значение, а не на имя переменной. Формат: MOIKA_PAYMENTS_KASPI_KEY',
  'prov.saved': 'Настройки провайдера сохранены',
  'prov.site': 'Объект',
  'prov.siteNetwork': 'Вся сеть',
  'prov.settings': 'Параметры подключения',
  'prov.settingsHint':
    'По строке «имя=значение», без секретов. ОФД (webkassa): cashboxUniqueNumber, vatPercent. Kaspi: organizationBin, deviceToken. Терминал: pollIntervalMs.',
  'prov.settingsInvalid': 'Строка без «=» или с недопустимым именем: {line}',
  'prov.rotated': 'Секрет перевыпущен',
  'prov.rotateConfirm': 'Перевыпустить секрет вебхука?',
  'prov.rotateEffect': 'Вебхук, настроенный на стороне провайдера со старым секретом, перестанет проходить',
  'prov.rotateOnce': 'Новый секрет показывается один раз — сразу перенесите его в настройки провайдера',
  'prov.status': 'Состояние',
  'prov.available': 'Доступен',
  'prov.unavailable': 'Недоступен',
  'prov.since': 'С',
  'prov.error': 'Ошибка',
  'prov.save': 'Сохранить',
  'prov.rotate': 'Перевыпустить секрет',
  'prov.secretOnce': 'Секрет показывается один раз, сохраните его сейчас',
  'prov.empty': 'Провайдеры не заведены',
  'prov.kind.acquiring': 'Эквайринг',
  'prov.kind.wallet': 'Кошелёк',
  'prov.kind.invoice': 'Безналичный расчёт',
  'prov.kind.fiscal': 'Фискализация',
  'common.loading': 'Загрузка…',
  'common.cancel': 'Отмена',
  'common.yes': 'Да',
  'common.no': 'Нет',
} as const;

const KK: Record<keyof typeof RU, string> = {
  'tab.transactions': 'Төлемдер',
  'tab.invoices': 'Шоттар',
  'tab.fiscal': 'Фискалдау',
  'tab.reconciliation': 'Салыстыру',
  'tab.providers': 'Провайдерлер',
  'module.subtitle': 'Транзакциялар, шоттар, фискалдандыру, көздерді салыстыру және провайдерлер',
  'tx.title': 'Төлем операциялары',
  'tx.date': 'Күні',
  'tx.provider': 'Провайдер',
  'tx.method': 'Тәсіл',
  'tx.method.pos': 'Касса',
  'tx.method.cash': 'Қолма-қол',
  'tx.method.card': 'Карта',
  'tx.method.kaspi': 'Kaspi',
  'tx.method.invoice': 'Шот бойынша',
  'tx.kind': 'Түрі',
  'tx.amount': 'Сома',
  'tx.status': 'Күйі',
  'tx.external': 'Провайдер идентификаторы',
  'tx.reason': 'Бас тарту себебі',
  'tx.refund': 'Қайтару',
  'tx.refundAmount': 'Қайтару сомасы, ₸',
  'tx.refundAll': 'Барлық қалдық',
  'tx.refundDone': 'Қайтару өткізілді',
  'tx.empty': 'Операциялар жоқ',
  'tx.filter': 'Клиент',
  'tx.filterHint':
    'Клиентті телефоны немесе көлік нөмірі бойынша табыңыз — оның операцияларын көрсетеміз.',
  'tx.load': 'Көрсету',
  'tx.kind.charge': 'Есептен шығару',
  'tx.kind.refund': 'Қайтару',
  'tx.kind.authorize': 'Авторизация',
  'tx.kind.capture': 'Растау',
  'tx.status.pending': 'Өңделуде',
  'tx.status.authorized': 'Авторизацияланған',
  'tx.status.captured': 'Өткізілген',
  'tx.status.failed': 'Қабылданбаған',
  'tx.status.refunded': 'Қайтарылған',
  'tx.partialRefund': 'Ішінара қайтару',
  'reason.insufficient_funds': 'Қаражат жеткіліксіз',
  'reason.card_expired': 'Карта мерзімі бітті',
  'reason.declined': 'Банк қабылдамады',
  'reason.provider_unavailable': 'Провайдер қолжетімсіз',
  'inv.title': 'Заңды тұлғаларға шоттар',
  'inv.consolidate.title': 'Автопарк келулері бойынша айдың бірыңғай шоты',
  'inv.consolidate.hint':
    'Келесі айдың басында өзі жиналады. Мұнда — таңдалған айға қазір жинау; қайталау ештеңені қайталамайды.',
  'inv.consolidate.month': 'Ай',
  'inv.consolidate.run': 'Шоттарды жинау',
  'inv.consolidate.done': 'Қойылған шоттар: {count}',
  'inv.number': 'Нөмірі',
  'inv.customer': 'Клиент',
  'inv.amount': 'Сома',
  'inv.status': 'Күйі',
  'inv.due': 'Мерзімі',
  'inv.paid': 'Төленген',
  'inv.pay': 'Төлемді белгілеу',
  'inv.empty': 'Шоттар жоқ',
  'inv.status.issued': 'Қойылған',
  'inv.status.paid': 'Төленген',
  'inv.status.cancelled': 'Тоқтатылған',
  'stmt.title': 'Банк үзіндісі',
  'stmt.hint':
    '1С форматындағы үзіндіні (1CClientBankExchange) жүктеңіз: мақсатында шот нөмірі және сол сома бар кіріс төлемдер шотты өздері жабады.',
  'stmt.upload': 'Үзіндіні жүктеу',
  'stmt.busy': 'Үзінді өңделуде…',
  'stmt.replayed': 'Бұл үзінді бұрын жүктелген — бұрынғы нәтиже көрсетілді, ештеңе қайта өткізілмеді.',
  'stmt.summary':
    'Құжаттар {documents}, кіріс {incoming}: төленді {matched}, бұрын төленген {alreadyPaid}, сома сәйкес емес {amountMismatch}, бөгде төлеуші {payerMismatch}, шот табылмады {notFound}, бұрын өткізілген {repeated}',
  'stmt.empty': 'Үзіндіде кіріс төлемдер жоқ',
  'stmt.doc': 'Құжат',
  'stmt.date': 'Күні',
  'stmt.amount': 'Сома',
  'stmt.payer': 'Төлеуші',
  'stmt.purpose': 'Төлем мақсаты',
  'stmt.invoice': 'Шот',
  'stmt.outcome': 'Нәтиже',
  'stmt.repeated': 'алдыңғы үзіндіден',
  'stmt.outcome.matched': 'Шот төленді',
  'stmt.outcome.already_paid': 'Бұрын төленген',
  'stmt.outcome.amount_mismatch': 'Сома сәйкес емес',
  'stmt.outcome.payer_mismatch': 'Бөгде төлеуші',
  'stmt.outcome.not_found': 'Шот табылмады',
  'stmt.history': 'Жүктелген үзінділер',
  'stmt.file': 'Файл',
  'stmt.period': 'Кезең',
  'stmt.loadedAt': 'Жүктелді',
  'fiscal.title': 'Фискалдық құжаттар',
  'fiscal.queue': 'Берілмегендер кезегі',
  'fiscal.retry': 'ОФД-ға беру',
  'fiscal.number': 'Фискалдық нөмір',
  'fiscal.ofd': 'ОФД идентификаторы',
  'fiscal.kind': 'Түрі',
  'fiscal.offline': 'Офлайн',
  'fiscal.attempts': 'Әрекет саны',
  'fiscal.error': 'Соңғы қате',
  'fiscal.empty': 'Құжаттар жоқ',
  'fiscal.kind.receipt': 'Чек',
  'fiscal.kind.refund': 'Қайтару чегі',
  'fiscal.transmitted': 'Берілген',
  'fiscal.pending': 'Беруді күтуде',
  'fiscal.skipped': 'Чекті бұрынғы ККМ берді',
  'fiscal.retried': 'Тексерілді {checked}, берілді {transmitted}, сәтсіз {failed}',
  'recon.title': 'Үш дереккөзді салыстыру',
  'recon.run': 'Салыстыруды бастау',
  'recon.day': 'Күні',
  'recon.provider': 'Провайдер',
  'recon.system': 'Жүйеде',
  'recon.providerCount': 'Провайдерде',
  'recon.fiscalCount': 'Фискалдық',
  'recon.findings': 'Алшақтық',
  'recon.empty': 'Алшақтық жоқ',
  'recon.incident': 'Алшақтық — бұл оқиға, есеп жолы емес',
  'recon.never': 'Салыстыру әлі жүргізілмеген',
  'recon.kind': 'Алшақтық түрі',
  'recon.kind.missing_in_provider': 'Провайдерде жоқ',
  'recon.kind.missing_in_system': 'Жүйеде жоқ',
  'recon.kind.amount_mismatch': 'Сомалар сәйкес емес',
  'recon.kind.missing_fiscal': 'Фискалдық құжат жоқ',
  'recon.kind.orphan_fiscal': 'Операциясыз фискалдық құжат',
  'prov.title': 'Төлем провайдерлері және ОФД',
  'prov.code': 'Коды',
  'prov.kind': 'Мақсаты',
  'prov.adapter': 'Адаптер',
  'prov.endpoint': 'Мекенжайы',
  'prov.credential': 'Кілті бар орта айнымалысы',
  'prov.credentialHint':
    'Тек айнымалының АТЫ: бас латын әріптері, сандар және астыңғы сызық. Мәні ортадан оқылады және базаға түспейді.',
  'prov.credentialInvalid':
    'Бұл айнымалы аты емес, мәннің өзіне ұқсайды. Пішімі: MOIKA_PAYMENTS_KASPI_KEY',
  'prov.saved': 'Провайдер баптаулары сақталды',
  'prov.site': 'Нысан',
  'prov.siteNetwork': 'Бүкіл желі',
  'prov.settings': 'Қосылу параметрлері',
  'prov.settingsHint':
    'Әр жолға «атау=мән», құпиясыз. ОФД (webkassa): cashboxUniqueNumber, vatPercent. Kaspi: organizationBin, deviceToken. Терминал: pollIntervalMs.',
  'prov.settingsInvalid': '«=» жоқ немесе атауы жарамсыз жол: {line}',
  'prov.rotated': 'Құпия сөз жаңартылды',
  'prov.rotateConfirm': 'Вебхук құпия сөзін жаңарту керек пе?',
  'prov.rotateEffect': 'Провайдер жағында ескі құпия сөзбен бапталған вебхук өтпей қалады',
  'prov.rotateOnce': 'Жаңа құпия сөз бір рет көрсетіледі — оны бірден провайдер баптауларына көшіріңіз',
  'prov.status': 'Күйі',
  'prov.available': 'Қолжетімді',
  'prov.unavailable': 'Қолжетімсіз',
  'prov.since': 'Бастап',
  'prov.error': 'Қате',
  'prov.save': 'Сақтау',
  'prov.rotate': 'Құпия сөзді жаңарту',
  'prov.secretOnce': 'Құпия сөз бір рет көрсетіледі, қазір сақтаңыз',
  'prov.empty': 'Провайдерлер енгізілмеген',
  'prov.kind.acquiring': 'Эквайринг',
  'prov.kind.wallet': 'Әмиян',
  'prov.kind.invoice': 'Қолма-қол ақшасыз есеп',
  'prov.kind.fiscal': 'Фискалдау',
  'common.loading': 'Жүктелуде…',
  'common.cancel': 'Болдырмау',
  'common.yes': 'Иә',
  'common.no': 'Жоқ',
};

export type PaymentsKey = keyof typeof RU;
export type PaymentsTranslate = (
  key: PaymentsKey,
  params?: Record<string, string | number>,
) => string;

const DICTIONARIES: Record<PaymentsLocale, Record<PaymentsKey, string>> = { ru: RU, kk: KK };

export function makePaymentsT(locale: PaymentsLocale): PaymentsTranslate {
  const dict = DICTIONARIES[locale] ?? RU;
  return (key, params) => {
    const template = dict[key] ?? RU[key] ?? key;
    if (!params) return template;
    return template.replace(/\{(\w+)\}/g, (match, name: string) =>
      params[name] === undefined ? match : String(params[name]),
    );
  };
}
